import React from 'react';
import { Loader2 } from 'lucide-react';
import { APP_LOGOS, LOGO_NEEDS_ADAPTIVE } from 'features/agents/WorkflowEditor/appLogos';
import { cx, neutralBtnCls } from 'features/agents/WorkflowEditor/fields/inputs';

/**
 * One row for "is this app connected": the app's mark, a line of text and,
 * when something needs doing, one link. Shared by the Slack, Linear and
 * GitHub connection checks so they read the same.
 *
 * tone: 'neutral' (connected) | 'warning' (needs a connection or a scope).
 */
export default function ConnectionStatus({ provider, loading, tone = 'neutral', title, children, action }) {
  const logo = APP_LOGOS[provider];
  const toneCls = tone === 'warning'
    ? 'border-[color:var(--feedback-warning)] bg-[color:var(--feedback-warning-bg)]'
    : 'border-[color:var(--border-default)] bg-[color:var(--surface-sunken)]';
  return (
    <div className={cx('flex items-center gap-2.5 rounded-md border px-2.5 py-2', toneCls)}>
      {loading ? (
        <Loader2 className="h-4 w-4 shrink-0 animate-spin text-[color:var(--text-muted)]" aria-hidden />
      ) : logo ? (
        <img src={logo} alt="" className={cx('h-4 w-4 shrink-0 object-contain', LOGO_NEEDS_ADAPTIVE.has(logo) && 'node-icon-adaptive')} />
      ) : null}
      <div className="min-w-0 flex-1 text-[12px] leading-snug">
        {title ? <div className="truncate font-medium text-[color:var(--text-primary)]">{title}</div> : null}
        {children ? <div className="text-[color:var(--text-muted)]">{children}</div> : null}
      </div>
      {action ? (
        <a href={action.href} className={cx(neutralBtnCls, 'h-7 shrink-0 bg-[color:var(--surface-base)]')}>{action.label}</a>
      ) : null}
    </div>
  );
}
